import { number, string } from 'prop-types'

const ProgressBar = ({ cssClass, progress }) => {
  return (
    <progress className={`progress is-info is-small ${cssClass}`} value={progress} max="100">{progress}</progress>
  )
}

ProgressBar.propTypes = {
  cssClass: string,
  progress: number
}

export default ProgressBar
